/** Shopify CDN: Minification failed

Line 17:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 27:16 Transforming const to the configured target environment ("es5") is not supported yet
Line 28:16 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:16 Transforming const to the configured target environment ("es5") is not supported yet

**/
Shopify.SearchByAllTypes = (() => {
	var config = {
		sectionId: 'main-page-article-grid',
        onComplete: null
	};
	return {
		renderResultTable: () => {
    		const section = document.getElementById(config.sectionId);

    		if(!section) return;

    		let url = section.getAttribute('data-url'),
                id = section.getAttribute('data-id');

    		fetch(url)
            .then(response => response.text())
            .then(responseText => {
                const html = responseText;
                const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                const resultElements = parsedHTML.querySelector(`div[id="${config.sectionId}"]`)?.querySelector('template').content.firstElementChild.cloneNode(true)

                if(resultElements && resultElements.innerHTML.trim().length) {
                    section.innerHTML = resultElements.innerHTML;
                } else {
                    section.remove();
                }
            })
            .catch(e => {
                console.error(e);
            });
		}
	}
})();